export const tokens = {
    text: {
        fontSize: 12,
    },
    value: {
        gap: 4,
    },
    icon: {
        size: 10,
    },
};
